import React, { Component, useRef, createRef } from 'react';
import { Map, Marker, Popup, TileLayer, Polygon,  Polyline, GeoJSON } from 'react-leaflet'
import FullscreenControl from 'react-leaflet-fullscreen';
import Control from 'react-leaflet-control';
import Choropleth from 'react-leaflet-choropleth';
import 'react-leaflet-fullscreen/dist/styles.css';



class OpenStreetMap extends Component {

  constructor(props) {
    super(props);
  }


  render() {



      return (
        <Map  style={{height: "45vw"}} center={[this.props.mapPositionLat, this.props.mapPositionLng]} zoom={this.props.mapZoomLevel}>
          <TileLayer
            attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {/* MARKERS */}
          {this.props.markers.map((row) =>
            <Marker position={[row[this.props.latName], row[this.props.lonName]]}>
              <Popup>
              <h4>{row[this.props.markerTitle]}</h4>
                <table>
              {this.props.markerPopupColumns.map(function(column, i){
                if ((column['priority'] === 'high' || column['priority'] === 'normal') && column['name'] !== this.props.markerTitle && row[column['name']]){
                  return <tr><td><b>{column['prettyName']}</b></td><td>{row[column['name']]}</td></tr>
                }
              },this)}
              </table>

                  {/*<a type="button"  class="btn btn-info btn-lg btn-block" href={'#row' + row['id']}>More information</a>*/}
              </Popup>
            </Marker>
            )}

            {/* POLYLINE */}
            {this.props.polylines.map((row) =>
              <Polyline  color="red" positions={row}>
                <Popup>
                   <h4>test</h4>
                </Popup>
              </Polyline>
              )}

              {/* POLYGON */}
              {this.props.polygons.map((row) =>
                <Polygon color="lime" positions={row}>
                  <Popup>
                    <h4>test</h4>
                  </Popup>
                </Polygon>
                )}

          <FullscreenControl position="topright" />
        </Map>
      )
    }
  }

export default OpenStreetMap;
